import styled from 'styled-components'

export const ContentWrapper = styled.div`
  padding: 30px 24px 0;
  color: ${({ theme }) => theme.color.darkGrey};
  line-height: 150%;
  > p {
    line-height: 150%;
    margin-bottom: 16px;
  }
`

export const FormGroup = styled.div`
  margin-bottom: 0;
  width: 100%;
  position: relative;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  margin-bottom: 24px;
`

export const FormGroupField = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
